//Library Imports
import { Button, Dropdown, Menu, Tooltip } from "antd";
import React, { useState } from "react";

//Local Imports
import styled from "styled-components";

interface IContactEmailDropdownSentEmail {
  emailsData: any;
  articleId: number;
}

const ContactEmailDropdownSentEmail: React.FC<IContactEmailDropdownSentEmail> = (
  props: IContactEmailDropdownSentEmail
) => {
  //Props
  const { emailsData, articleId } = props;
  //   console.log(emailsData);

  //Local States
  const [ellipsisState, setEllipsistate] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const menu = () => (
    <Menu>
      <Style>
        <div className="email-container">
          <div className="email-list">
            <text className="text-style heading">Multiple Assets</text>
            {Object.values(emailsData).map((item: any) => (
              <Tooltip placement="top" title={item.emailName}>
                <div className="d-flex flex-column text-style mail-data">
                  <div>{item.emailName}</div>
                  <div>{item.lastSent}</div>
                </div>
              </Tooltip>
            ))}
          </div>
        </div>
      </Style>
    </Menu>
  );
  return (
    <Dropdown
      overlay={menu}
      placement="bottomRight"
      trigger="click"
      overlayClassName="dropdown-checked-by-multiple-emails"
      onVisibleChange={(visible: boolean) => {
        setIsVisible(visible);
      }}
      visible={isVisible}
    >
      <Button className="email-btn">
        {emailsData.length}
        <span className="ant-select-arrow" unselectable="on" aria-hidden="true" style={{ userSelect: "none" }}>
          <span role="img" aria-label="down" className="anticon anticon-down ant-select-suffix">
            <svg
              viewBox="64 64 896 896"
              focusable="false"
              data-icon="down"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path>
            </svg>
          </span>
        </span>
      </Button>
    </Dropdown>
  );
};

export default ContactEmailDropdownSentEmail;

const Style = styled.div`
  padding: 10px;
  .text-style {
    font-size: 16px;
    font-family: "Roboto";
    font-weight: 500;
    &.heading {
      color: #424b50;
    }
    &.mail-data {
      color: #7e7e7e;
      margin-top: 15px;
    }
  }
`;
